import { render, staticRenderFns } from "./BigPictureWrapper.vue?vue&type=template&id=2dd479b1&scoped=true&"
import script from "./BigPictureWrapper.vue?vue&type=script&lang=ts&"
export * from "./BigPictureWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./BigPictureWrapper.vue?vue&type=style&index=0&id=2dd479b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd479b1",
  null
  
)

export default component.exports